window.addEventListener('DOMContentLoaded', function () {
  appHeight();

  document.querySelectorAll('.quantity-picker').forEach(function (picker, index) {
    let numberInput = picker.querySelector('.quantity-selector');

    picker.querySelector('.plus').addEventListener('click', function () {
      numberInput.stepUp();
    });

    picker.querySelector('.minus').addEventListener('click', function () {
      numberInput.stepDown();
    });
  });

  let videoHolders = document.querySelectorAll('div.video-holder[data-poster]');
  videoHolders.forEach(function (videoHolder) {
    let video = videoHolder.querySelector('video');
    let poster = videoHolder.dataset.poster;
    if (poster) {
      video.setAttribute('poster', poster);
    }
  });
});



document.addEventListener('DOMContentLoaded', (event) => {
    const utmParams = getUTMParameters();
    console.log(`UTM PARAMETERS`);
    console.log(utmParams);

    if (Object.keys(utmParams).length === 0) return; // Exit if no UTM params

    const utmString = new URLSearchParams(utmParams).toString();

    document.querySelectorAll('a').forEach(anchor => {
        const href = anchor.getAttribute('href');

        // Skip if no href or it's an anchor link
        if (!href || href.startsWith('#')) return;

        const separator = href.includes('?') ? '&' : '?';
        anchor.setAttribute('href', href + separator + utmString);
        
    });
});

function getUTMParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const utms = {};

    urlParams.forEach((value, key) => {
        //console.log(`${key} : ${value}`);
        if (key.startsWith('utm_') || key.startsWith('gclid') || key.startsWith('msclkid')) {
            utms[key] = value;
        }
    });
    console.log(utms);

    return utms;
}

window.addEventListener('load', function () {
  console.log(Shopify);

  Shopify.onItemAdded = function (line_item) {
    console.log('Item added to cart:', line_item);
    alert('ADDED TO CART');
  };

  function runWhenInit() {
    //console.log('The current cart state is: ', window.liquidAjaxCart.cart-holder);
  }

  if (window.liquidAjaxCart?.init) {
    // if Liquid Ajax Cart is already initialized
    runWhenInit();
  } else {
    // wait for Liquid Ajax Cart to be initialized
    document.addEventListener('liquid-ajax-cart:init', runWhenInit);
  }

  runWhenInit();

  arrowButtons = document.querySelectorAll('.navArrow');

  submenus = document.querySelectorAll('.sub-menu');

  ////console.log('Arrow buttons' + arrowButtons.length);
  ////console.log('Submenus' + submenus.length);

  // arrowButtons.forEach(function (arrowButton, index) {
  //   if (onMobile()) {
  //     arrowButton.addEventListener('click', function () {
  //       submenus[index].classList.toggle('shown');
  //       arrowButton.classList.toggle('flipped');
  //       if (submenus[index].classList.contains('shown')) {
  //         submenus[index].style.maxHeight = submenus[index].scrollHeight + 'px';
  //       } else {
  //         submenus[index].style.maxHeight = 0 + 'px';
  //       }
  //     });
  //   } else {
  //     // Initialize flag for each pair
  //     submenus[index].classList.remove('shown');

  //     // Timeout variable to track delay
  //     let timeout;

  //     const overlay = document.querySelector('.overlay');

  //     // Function to set flag to true and clear timeout
  //     function handleMouseEnter() {
  //       overlay.classList.add('megamenu-open');

  //       //alert('Mouse entered this element');
  //       submenus[index].classList.add('shown');
  //       clearTimeout(timeout);
  //       if (submenus[index].classList.contains('shown')) {
  //         submenus[index].style.maxHeight = submenus[index].scrollHeight + 'px';
  //       } else {
  //         submenus[index].style.maxHeight = 0 + 'px';
  //       }
  //     }

  //     // Function to set flag to false with a delay
  //     function handleMouseLeave() {
  //       overlay.classList.remove('megamenu-open');

  //       timeout = setTimeout(() => {
  //         submenus[index].classList.remove('shown');
  //         if (submenus[index].classList.contains('shown')) {
  //           submenus[index].style.maxHeight = submenus[index].scrollHeight + 'px';
  //         } else {
  //           submenus[index].style.maxHeight = 0 + 'px';
  //         }
  //       }, 200); // 1000 milliseconds = 1 second
  //     }

  //     // Function to handle mouse enter and leave for both elements
  //     arrowButton.addEventListener('mouseenter', handleMouseEnter);
  //     arrowButton.addEventListener('mouseleave', handleMouseLeave);
  //     submenus[index].addEventListener('mouseenter', handleMouseEnter);
  //     submenus[index].addEventListener('mouseleave', handleMouseLeave);
  //   }
  // });

  function fixAccordionIcons(accordionButton) {
    svgSet = accordionButton.querySelectorAll('svg');

    svgSet.forEach(function (svg, index) {
      topValue = window.getComputedStyle(svg).getPropertyValue('top');
      svg.style.top = topValue;
    });
  }

  const accordions = document.querySelectorAll('.accordion');

  accordions.forEach(function (accordion, index) {
    let maxHeight = 0;
    let accordionButtons = accordion.querySelectorAll('.accordion-button');
    let accordionContents = accordion.querySelectorAll('.accordion-content');
    accordionButtons.forEach(function (accordionButton, index) {
      maxHeight = Math.max(maxHeight, accordionButton.offsetheight);
      let accordionContent = accordionButton.querySelector('.accordion-content');
      accordionButton.addEventListener('click', function (e) {
        if (!e.target.classList.contains('inside')) {
          accordionButton.classList.toggle('active');
          if (accordionButton.classList.contains('active')) {
            fixAccordionIcons(accordionButton);
            accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
          } else {
            accordionContent.style.maxHeight = 0;
          }

          const otherAccordionButtons = Array.from(accordionButtons).filter((button) => button !== accordionButton);
          otherAccordionButtons.forEach(function (otherAccordionButton, index) {
            otherAccordionButton.classList.remove('active');
          });

          const otherAccordionContents = Array.from(accordionContents).filter(
            (content) => content !== accordionContent,
          );
          otherAccordionContents.forEach(function (otherAccordionContent, index) {
            otherAccordionContent.classList.remove('active');
            otherAccordionContent.style.maxHeight = 0;
          });
        }
      });
    });
    accordion.style.height = maxHeight * accordions.length + 'px';
  });
});

const appHeight = () => document.documentElement.style.setProperty('--mobile-height', `${window.innerHeight}px`);
appHeight();

/* This  */

function onMobile() {
  const screenWidth = window.screen.width;
  return screenWidth > 850 ? false : true;
}

function getTimeUntilNextMidnight() {
  var now = new Date();
  var midnight = new Date();
  midnight.setHours(24, 0, 0, 0); // Set to next midnight

  var timeUntilMidnight = midnight - now;

  var hours = Math.floor(timeUntilMidnight / (1000 * 60 * 60))
    .toString()
    .padStart(2, '0');
  var minutes = Math.floor((timeUntilMidnight % (1000 * 60 * 60)) / (1000 * 60))
    .toString()
    .padStart(2, '0');
  var seconds = Math.floor((timeUntilMidnight % (1000 * 60)) / 1000)
    .toString()
    .padStart(2, '0');

  return hours + ':' + minutes + ':' + seconds;
}

function setTimers() {
  timers = document.querySelectorAll('.discount-timer');
  timers.forEach(function (timer) {
    // Set the inner HTML of each element
    timer.innerHTML = getTimeUntilNextMidnight();
  });
}

setInterval(function () {
  setTimers();
}, 1000);

const megamenu_observer = new MutationObserver(function (mutationsList, observer) {
  // Iterate through the list of mutations
  for (let mutation of mutationsList) {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class' &&
      (mutation.target.classList.contains('active') || mutation.target.classList.contains('megamenu-open'))
    ) {
      //class being added
      mutation.target.style.zIndex = '2';
    }
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class' &&
      !mutation.target.classList.contains('active') &&
      !mutation.target.classList.contains('megamenu-open')
    ) {
      // class being removed
      mutation.target.style.zIndex = '2';
      setTimeout(function () {
        if (!mutation.target.classList.contains('active') && !mutation.target.classList.contains('megamenu-open')) {
          mutation.target.style.zIndex = '-1';
        }
      }, 500);
    }
  }
});

// Configure the MutationObserver to observe changes to attributes
const observerConfig = { attributes: true, subtree: true };

// Start observing the target element

const slideout = document.querySelector('.slideout-menu');
const header = document.querySelector('.header-group');
const placeholder = document.querySelector('.placeholder');
const overlay = document.querySelector('.overlay');
const slideCart = document.querySelector('.slideout-cart');
const desktopSlideCart = document.querySelector('header.desktop .cart-holder');
const popupWithImage = document.querySelector('.exitIntent');

// This breaks on the live site, but should be fine on the final publish of the dev site :fingers-crossed:
megamenu_observer.observe(overlay, observerConfig);

const desktopCartPressed = (event) => {
  const burgerButton = document.querySelector('.hamburger');
  slideCart.classList.toggle('closed');
  burgerButton.classList.remove('active');

  let closed = slideCart.classList.contains('closed');

  if (closed) {
    if (popupWithImage == null || popupWithImage.classList.contains('closed')) {
      document.body.classList.remove('fix-desktop');
      overlay.classList.remove('active');
    }
  } else {
    document.body.classList.add('fix-desktop');
    overlay.classList.add('active');
  }
  appHeight();
};

const cartPressed = (event) => {
  const burgerButton = document.querySelector('.hamburger');
  const cartButton = document.querySelector('.cart-holder');
  slideout.classList.add('closed');
  slideCart.classList.toggle('closed');
  burgerButton.classList.remove('active');

  let closed = slideCart.classList.contains('closed');

  if (closed) {
    if (popupWithImage == null || popupWithImage.classList.contains('closed')) {
      document.body.classList.remove('fix-mobile');
      overlay.classList.remove('active');
    }
  } else {
    document.body.classList.add('fix-mobile');
    overlay.classList.add('active');
  }
  appHeight();
};

const burgerPressed = (event) => {
  const burgerButton = document.querySelector('.hamburger');
  const cartButton = document.querySelector('.cart-holder-holder');
  slideCart.classList.add('closed');
  slideout.classList.toggle('closed');

  let closed = slideout.classList.contains('closed');

  if (closed) {
    if (popupWithImage == null || popupWithImage.classList.contains('closed')) {
      document.body.classList.remove('fix-mobile');
      overlay.classList.remove('active');
    }
    burgerButton.classList.remove('active');
  } else {
    document.body.classList.add('fix-mobile');
    overlay.classList.add('active');
    burgerButton.classList.add('active');
  }
  appHeight();
};

const overlayPressed = (event) => {
  const burgerButton = document.querySelector('.hamburger');
  const cartButton = document.querySelector('.cart-holder');
  slideCart.classList.add('closed');
  slideout.classList.add('closed');
  burgerButton.classList.remove('active');

  if (popupWithImage == null || popupWithImage.classList.contains('closed')) {
    document.body.classList.remove('fix-mobile');
    overlay.classList.remove('active');
  }
};

document.querySelector('.overlay').addEventListener('click', overlayPressed);
document.querySelector('.hamburger').addEventListener('click', burgerPressed);
document.querySelector('.cart-holder').addEventListener('click', cartPressed);
desktopSlideCart.addEventListener('click', desktopCartPressed);

document.querySelectorAll('.add-to-cart-section button').forEach(function (button) {
  button.addEventListener('click', function () {
    header.classList.remove('hidden');
    setTimeout(() => {
      header.classList.remove('hidden');
      cartPressed();
    }, 2500);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  updatePlaceholderSize(); // Set placeholder size initially
  window.addEventListener('resize', updatePlaceholderSize); // Update placeholder size on window resize
});

function updatePlaceholderSize() {
  var fixedSection = document.querySelector('.header-group');
  var placeholder = document.querySelector('.placeholder');
  var sectionHeight = Math.floor(fixedSection.scrollHeight);
  placeholder.style.height = sectionHeight - 1 + 'px'; //Takes away 1px as sometimes the placeholder is rendering of the header can be inconsistent due to fractional pixel values
  document.documentElement.style.setProperty('--header-size', sectionHeight + 'px'); // Update the value of the CSS variable
}

var lastScrollTop = 0; // Variable to store the last scroll position
var consecutiveScrollUpDistance = 0; // Variable to store the consecutive scroll up distance
var consecutiveScrollDownDistance = 0; // Variable to store the consecutive scroll up distance
var scrollThreshold = window.innerHeight * 0.1; // Scroll threshold set to 5% of the viewport height

window.addEventListener('scroll', function (event) {
  if (onMobile()) {
    activateLastPricingCard();
  }
  var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScrollTop < lastScrollTop) {
    // Scrolling up
    consecutiveScrollDownDistance = 0;
    consecutiveScrollUpDistance += lastScrollTop - currentScrollTop;
  } else {
    // Scrolling down
    consecutiveScrollUpDistance = 0;
    consecutiveScrollDownDistance += currentScrollTop - lastScrollTop;
  }

  if (consecutiveScrollDownDistance >= scrollThreshold) {
    consecutiveScrollDownDistance = 0;
    if (slideout.classList.contains('closed')) {
      header.classList.add('hidden');
    }
  }

  const headerSize = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-size').trim(), 10);
  if (consecutiveScrollUpDistance >= scrollThreshold || lastScrollTop < headerSize) {
    //Scrolled above the threshold
    consecutiveScrollUpDistance = 0;
    header.classList.remove('hidden');
  }

  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
});

const cartButtons = document.querySelectorAll("form.shopify-product-form button[type='submit']");

cartButtons.forEach(function (cartButton, index) {
  cartButton.addEventListener('click', function (event) {
    if (!cartButton.classList.contains('loading')) {
      cartButton.classList.add('loading');
      //The value for this timeout must equal the animation length and delay of the cart svg (i.e.  animation: cart 2s linear forwards 0.2s; means a delay of 2200ms)
      setTimeout(() => cartButton.classList.remove('loading'), 2700);
    }
  });
});

function isElementInViewport(el) {
  // Special bonus for those using jQuery
  if (typeof jQuery === 'function' && el instanceof jQuery) {
    el = el[0];
  }

  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}

function activateLastPricingCard() {
  pricingCards = document.querySelectorAll('.pricing-card');

  // Calculate the center coordinates of the viewport
  const centerX = window.innerWidth / 2;
  const centerY = window.innerHeight / 2;

  // Get all elements at the center of the viewport
  const elementsAtCenter = document.elementsFromPoint(centerX, centerY);

  let centerCard = null;

  // Iterate over the elements and log each one
  elementsAtCenter.forEach((element, index) => {
    if (element.classList.contains('pricing-card')) {
      centerCard = element;
    }
  });

  if (centerCard) {
    pricingCards.forEach(function (pricingCard) {
      if (centerCard == pricingCard) {
        pricingCard.classList.add('active');
      } else {
        pricingCard.classList.remove('active');
      }
    });
  }
}

